import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a physical or digital product?',
    a: "This is a 100% digital system (High-Resolution PDFs). It's optimized for iPad, Tablet, or Smartphone use, so you can have your entire library with you on the court."
  }, {
    q: 'Do I get access to updates?',
    a: 'Yes! All future tactical updates for the current edition are included for free — once you own the pack, you keep it for life.'
  }, {
    q: 'How is the content delivered?',
    a: "Instantly. After a successful checkout, you'll receive an email with your secure download link to access all 6 volumes immediately."
  }, {
    q: 'Do I need to be an experienced coach to use this?',
    a: 'No. The system is designed for coaches at every level. Every drill and play is explained step by step with clear coaching cues so you can run it with confidence on day one.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-bb-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <div className="bg-bb-orange/10 text-bb-orange-dark font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-57">
            Frequently Asked Questions
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight tracking-tight" data-id="element-58">
            Got <span className="text-bb-orange" data-id="element-59">questions?</span> We've got
            answers
          </h2>
        </div>

        <div className="space-y-3" data-id="element-60">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-bb-line overflow-hidden shadow-sm" data-id="element-61">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-bb-light/50 transition-colors" data-id="element-62">
                <span className="font-display font-semibold uppercase text-base sm:text-lg text-bb-charcoal pr-4 tracking-wide" data-id="element-63">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-bb-orange text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-64">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-65" /> : <Plus className="w-4 h-4" data-id="element-66" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-bb-slate leading-relaxed" data-id="element-67">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}